
<div class="row mb-1">
  <div class="col-md-12">
    Risco Identificado
    <ng-select
      [disabled]="visualizar"
      id="selectRiscoIdentificado"
      (change)="changeRisco()"
      [(ngModel)]="riscoSelecionado">
      <ng-option [value]="obj.controle" *ngFor="let obj of objPrincipal.riscos">{{ obj.descricaoRisco }}</ng-option>
    </ng-select>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Descrição do Controle
    <input type="text" [disabled]="visualizar"
      id="txtDescricaoControle" class="form-control form-control-sm"
      [(ngModel)]="txtDescricaoControle" maxlength="255" />
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Avaliação
    <ng-select
      id="selectAvaliacao" [disabled]="visualizar"
      [(ngModel)]="avaliacaoControleSelecionada"
      (change)="changeAvaliacao()">
      <ng-option [value]="obj.id" *ngFor="let obj of listAvaliacaoControle">{{ obj.avaliacao }}</ng-option>
    </ng-select>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-4">
    Risco de Controle (RC)
    <input type="text"
      [disabled]="true"
      id="txtValorRR" class="form-control form-control-sm"
      [(ngModel)]="txtValorRR" maxlength="255" />
  </div>
  <div class="col-md-4">
    Risco Residual
    <input type="text"
      [disabled]="true"
      id="txtCalculoRR" class="form-control form-control-sm"
      [(ngModel)]="txtCalculoRR" maxlength="255" />
  </div>
  <div class="col-md-4">
    Nível de Risco Residual
    <input type="text"
      [disabled]="true"
      id="txtNivelRR" class="form-control form-control-sm"
      [(ngModel)]="txtNivelRR" maxlength="255" />
  </div>
</div>
<div class="row mb-2">
  <div class="col-md-12">
    Melhor Prática de Controle identificadas pela equipe    
    <textarea [disabled]="visualizar" id="txtMelhorPratica" rows="2"
      class="form-control form-control-sm" 
      [(ngModel)]="txtMelhorPratica" maxlength="255">
    </textarea>
  </div>
</div>
<div class="row mb-2" *ngIf="!visualizar">
  <div class="col-md-8"></div>
  <div class="col-md-4" style="text-align: right;">
    <button type="button" class="btn btn-primary btn-sm" (click)="novo()">
      <i class="fas fa-file"></i> Novo
    </button>
    &nbsp;
    <button type="button" class="btn btn-success btn-sm" (click)="adicionar()">
      <i class="fas fa-plus"></i> {{ getNameBtn() }}
    </button>
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h4>Lista de Controles Associados</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-grid-abas-matriz-risco [dados]="objPrincipal.associados"
          [listColunas]="listColunas"
          [visualizar]="this.visualizar"
          [siglaPosicao]="'C'"
          (btnRemover)="remover($event)"
          (btnEditar)="editar($event)"></app-grid-abas-matriz-risco>
      </div>
    </div>
  </div>
</div>
